import { render } from "./MethodComparison.vue?vue&type=template&id=2c88ce2e&scoped=true"
import script from "./MethodComparison.vue?vue&type=script&lang=js"
export * from "./MethodComparison.vue?vue&type=script&lang=js"

import "./MethodComparison.vue?vue&type=style&index=0&id=2c88ce2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c88ce2e"]])

export default __exports__